// 8e15e15b-ecdb-4702-bcea-a76a6e64b8c8
import React, { useEffect, useState, useCallback, useMemo, useRef } from "react";
import { MapContainer, TileLayer, Marker, Tooltip, Polyline, useMap } from "react-leaflet";
import { useParams } from "react-router-dom";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-polylinedecorator";
import moment from "moment";
import axios from "axios";
import MarkerClusterGroup from "react-leaflet-cluster";
import "leaflet.markercluster/dist/leaflet.markercluster.js";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";

// Custom icons
const punchInIcon = new L.Icon({
    iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-green.png",
    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});

const punchOutIcon = new L.Icon({
    iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-red.png",
    shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
    iconSize: [20, 35],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41]
});

// const currentLocationIcon = new L.Icon({
//     iconUrl: "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-blue.png",
//     shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
//     iconSize: [25, 41],
//     iconAnchor: [12, 41],
//     popupAnchor: [1, -34],
//     shadowSize: [41, 41]
// });

const liveLocationIcon = new L.DivIcon({
    className: "live-location-icon",
    html: `
        <div style="
            width: 18px;
            height: 18px;
            background: green;
            border-radius: 50%;
            box-shadow: 0 0 10px red;
            animation: pulseLive 1.5s infinite;
        "></div>
    `,
    iconSize: [18, 18],
    iconAnchor: [9, 9]
});

// Component to handle map view updates
const MapController = ({ center, shouldUpdate }) => {
    const map = useMap();
    
    useEffect(() => {
        if (shouldUpdate && center && center.length === 2) {
            map.setView(center, map.getZoom());
        }
    }, [center, shouldUpdate, map]);
    
    return null;
};

// Custom arrow polyline component with arrows every specified km
// Hides arrows when zoom level is <= CLUSTER_DISABLE_ZOOM (clustering active)
// const ArrowPolyline = ({ positions, color = 'red', polylineColor = 'blue', weight = 4, opacity = 0.8, arrowIntervalKm = 10 }) => {
//     const map = useMap();
//     const arrowRef = useRef(null);
//     const [zoom, setZoom] = useState(() => map?.getZoom() || 11);
//     const CLUSTER_DISABLE_ZOOM = 10;

//     const normalizePositions = useCallback((pos) => {
//         if (!pos || pos.length < 2) return [];
//         return pos.map(p => {
//             if (Array.isArray(p) && p.length >= 2) {
//                 return { lat: Number(p[0]), lng: Number(p[1]) };
//             } else if (p.latitude !== undefined && p.longitude !== undefined) {
//                 return { lat: Number(p.latitude), lng: Number(p.longitude) };
//             } else if (p.lat !== undefined && p.lng !== undefined) {
//                 return { lat: Number(p.lat), lng: Number(p.lng) };
//             }
//             return null;
//         }).filter(p => p !== null && !isNaN(p.lat) && !isNaN(p.lng));
//     }, []);

//     const calculateBearing = useCallback((lat1, lng1, lat2, lng2) => {
//         const φ1 = lat1 * Math.PI / 180;
//         const φ2 = lat2 * Math.PI / 180;
//         const Δλ = (lng2 - lng1) * Math.PI / 180;
//         const y = Math.sin(Δλ) * Math.cos(φ2);
//         const x = Math.cos(φ1) * Math.sin(φ2) - Math.sin(φ1) * Math.cos(φ2) * Math.cos(Δλ);
//         let θ = Math.atan2(y, x);
//         return (θ * 180 / Math.PI + 360) % 360;
//     }, []);

//     const getArrowPositions = useCallback(() => {
//         const validPositions = normalizePositions(positions);
//         if (validPositions.length < 2) return [];

//         let totalLength = 0;
//         const segments = [];

//         for (let i = 1; i < validPositions.length; i++) {
//             const from = L.latLng(validPositions[i-1].lat, validPositions[i-1].lng);
//             const to = L.latLng(validPositions[i].lat, validPositions[i].lng);
//             const segLength = from.distanceTo(to);

//             totalLength += segLength;

//             segments.push({
//                 start: validPositions[i-1],
//                 end: validPositions[i],
//                 length: segLength,
//                 cumulative: totalLength
//             });
//         }

//         const intervalMeters = arrowIntervalKm * 1000;
//         const arrowPositions = [];
//         let currentDist = intervalMeters;

//         while (currentDist < totalLength) {
//             let accumulated = 0;

//             for (const seg of segments) {
//                 if (currentDist <= seg.cumulative) {
//                     const remaining = currentDist - accumulated;
//                     const ratio = remaining / seg.length;

//                     const lat = seg.start.lat + (seg.end.lat - seg.start.lat) * ratio;
//                     const lng = seg.start.lng + (seg.end.lng - seg.start.lng) * ratio;

//                     const bearing = calculateBearing(
//                         seg.start.lat,
//                         seg.start.lng,
//                         seg.end.lat,
//                         seg.end.lng
//                     );

//                     arrowPositions.push({ lat, lng, bearing });
//                     break;
//                 }

//                 accumulated = seg.cumulative;
//             }

//             currentDist += intervalMeters;
//         }

//         return arrowPositions;
//     }, [positions, arrowIntervalKm, normalizePositions, calculateBearing]);

//     useEffect(() => {
//         if (!map) return;

//         const handleZoom = () => setZoom(map.getZoom());

//         map.on('zoomend', handleZoom);
//         handleZoom();

//         return () => map.off('zoomend', handleZoom);
//     }, [map]);

//     useEffect(() => {
//         if (!map || !positions || positions.length < 2) return;

//         if (arrowRef.current) {
//             arrowRef.current.forEach(m => m.remove());
//             arrowRef.current = null;
//         }

//         if (zoom <= CLUSTER_DISABLE_ZOOM) return;

//         const timer = setTimeout(() => {
//             const arrows = getArrowPositions();
//             const arrowMarkers = [];

//             arrows.forEach((arrow) => {
//                 const rotation = arrow.bearing - 90;

//                 const arrowIcon = L.divIcon({
//                     className: 'direction-arrow',
//                     html: `
//                         <div style="
//                             --rotate: ${rotation}deg;
//                             transform: rotate(${rotation}deg);
//                             font-size: 20px;
//                             color: ${color};
//                             line-height: 1;
//                             text-shadow: 0 0 3px white;
//                             font-weight: bold;
//                         ">➤</div>
//                     `,
//                     iconSize: [20, 20],
//                     iconAnchor: [10, 10],
//                 });

//                 const marker = L.marker([arrow.lat, arrow.lng], {
//                     icon: arrowIcon,
//                     interactive: false,
//                     zIndexOffset: 1000
//                 }).addTo(map);

//                 arrowMarkers.push(marker);
//             });

//             arrowRef.current = arrowMarkers;
//         }, 150);

//         return () => {
//             clearTimeout(timer);
//             if (arrowRef.current) {
//                 arrowRef.current.forEach(m => m.remove());
//                 arrowRef.current = null;
//             }
//         };
//     }, [map, positions, getArrowPositions, color, zoom]);

//     const polylinePositions = useMemo(() => {
//         const valid = normalizePositions(positions);
//         return valid.map(p => [p.lat, p.lng]);
//     }, [positions, normalizePositions]);

//     if (polylinePositions.length < 2) return null;

//     return (
//         <Polyline
//             positions={polylinePositions}
//             color={polylineColor}
//             weight={weight}
//             opacity={opacity}
//             smoothFactor={1}
//         />
//     );
// };

// const ArrowPolyline = ({ positions, polylineColor = 'blue', weight = 4, opacity = 0.8, arrowIntervalKm = 10 }) => {
//     const map = useMap();
//     const polylineRef = useRef(null);
//     const decoratorRef = useRef(null);

//     const normalizePositions = useCallback((pos) => {
//         if (!pos || pos.length < 2) return [];
//         return pos.map(p => {
//             if (Array.isArray(p)) return [Number(p[0]), Number(p[1])];
//             if (p.latitude && p.longitude) return [Number(p.latitude), Number(p.longitude)];
//             if (p.lat && p.lng) return [Number(p.lat), Number(p.lng)];
//             return null;
//         }).filter(Boolean);
//     }, []);

//     const getDistance = (coords) => {
//         let distance = 0;
//         for (let i = 1; i < coords.length; i++) {
//             const from = L.latLng(coords[i - 1]);
//             const to = L.latLng(coords[i]);
//             distance += from.distanceTo(to);
//         }
//         return distance;
//     };

//     useEffect(() => {
//         if (!map || !positions || positions.length < 2) return;

//         const latlngs = normalizePositions(positions);
//         if (latlngs.length < 2) return;

//         // Remove old layers
//         if (polylineRef.current) {
//             map.removeLayer(polylineRef.current);
//         }
//         if (decoratorRef.current) {
//             map.removeLayer(decoratorRef.current);
//         }

//         // Create polyline
//         const polyline = L.polyline(latlngs, {
//             color: polylineColor,
//             weight,
//             opacity,
//             smoothFactor: 1
//         }).addTo(map);

//         polylineRef.current = polyline;

//         // Calculate spacing dynamically based on km
//         const totalDistance = getDistance(latlngs);
//         const repeatPixels = Math.max((arrowIntervalKm * 1000 / totalDistance) * 100, 5);

//         // Create decorator (arrows)
//         const decorator = L.polylineDecorator(polyline, {
//             patterns: [
//                 {
//                     offset: '5%',
//                     repeat: `${repeatPixels}%`,
//                     symbol: L.Symbol.arrowHead({
//                         pixelSize: 10,
//                         polygon: true,
//                         pathOptions: {
//                             fillOpacity: 1,
//                             weight: 0,
//                             color: 'red',
//                             fillColor: 'red'
//                         }
//                     })
//                 }
//             ]
//         }).addTo(map);

//         decoratorRef.current = decorator;

//         return () => {
//             if (polylineRef.current) map.removeLayer(polylineRef.current);
//             if (decoratorRef.current) map.removeLayer(decoratorRef.current);
//         };

//     }, [map, positions, polylineColor, weight, opacity, arrowIntervalKm, normalizePositions]);

//     return null;
// };

// const ArrowPolyline = ({
//     positions,
//     weight = 5,
//     opacity = 0.9,
//     arrowIntervalKm = 10
// }) => {
//     const map = useMap();
//     const polylineLayersRef = useRef([]);
//     const decoratorRef = useRef(null);
//     const animationRef = useRef(null);
//     const [zoom, setZoom] = useState(() => map?.getZoom() || 11);

//     const CLUSTER_DISABLE_ZOOM = 8; // hide arrows below this

//     const normalizePositions = useCallback((pos) => {
//         if (!pos || pos.length < 2) return [];
//         return pos.map(p => {
//             if (Array.isArray(p)) return [Number(p[0]), Number(p[1])];
//             if (p.latitude && p.longitude) return [Number(p.latitude), Number(p.longitude)];
//             if (p.lat && p.lng) return [Number(p.lat), Number(p.lng)];
//             return null;
//         }).filter(Boolean);
//     }, []);

//     // 🌈 Gradient colors
//     const getColor = (t) => {
//         const start = [33, 150, 243]; // blue
//         const end = [244, 67, 54];    // red

//         const r = Math.round(start[0] + (end[0] - start[0]) * t);
//         const g = Math.round(start[1] + (end[1] - start[1]) * t);
//         const b = Math.round(start[2] + (end[2] - start[2]) * t);

//         return `rgb(${r},${g},${b})`;
//     };

//     const getDistance = (coords) => {
//         let distance = 0;
//         for (let i = 1; i < coords.length; i++) {
//             const from = L.latLng(coords[i - 1]);
//             const to = L.latLng(coords[i]);
//             distance += from.distanceTo(to);
//         }
//         return distance;
//     };

//     // 👀 Track zoom
//     useEffect(() => {
//         if (!map) return;

//         const handleZoom = () => setZoom(map.getZoom());

//         map.on("zoomend", handleZoom);
//         handleZoom();

//         return () => map.off("zoomend", handleZoom);
//     }, [map]);

//     useEffect(() => {
//         if (!map || !positions || positions.length < 2) return;

//         const latlngs = normalizePositions(positions);
//         if (latlngs.length < 2) return;

//         // Cleanup old
//         polylineLayersRef.current.forEach(layer => map.removeLayer(layer));
//         polylineLayersRef.current = [];

//         if (decoratorRef.current) map.removeLayer(decoratorRef.current);
//         if (animationRef.current) cancelAnimationFrame(animationRef.current);

//         // 🌈 Create gradient polyline (segment-based)
//         for (let i = 1; i < latlngs.length; i++) {
//             const t = i / latlngs.length;
//             const segment = L.polyline([latlngs[i - 1], latlngs[i]], {
//                 color: getColor(t),
//                 weight,
//                 opacity,
//                 smoothFactor: 1
//             }).addTo(map);

//             polylineLayersRef.current.push(segment);
//         }

//         // ❌ Hide arrows if zoom is low
//         if (zoom <= CLUSTER_DISABLE_ZOOM) return;

//         const totalDistance = getDistance(latlngs);
//         const repeatPercent = Math.max((arrowIntervalKm * 1000 / totalDistance) * 100, 5);

//         let offset = 0;

//         const createDecorator = (offsetValue) => {
//             return L.polylineDecorator(latlngs, {
//                 patterns: [
//                     {
//                         offset: `${offsetValue}%`,
//                         repeat: `${repeatPercent}%`,
//                         symbol: L.Symbol.arrowHead({
//                             pixelSize: 12,
//                             polygon: true,
//                             pathOptions: {
//                                 fillOpacity: 1,
//                                 weight: 0,
//                                 color: "#000",
//                                 fillColor: "#000"
//                             }
//                         })
//                     }
//                 ]
//             });
//         };

//         // initial arrows
//         decoratorRef.current = createDecorator(offset).addTo(map);

//         // 🔥 Animation
//         const animate = () => {
//             offset += 0.25; // speed control

//             if (offset > 100) offset = 0;

//             if (decoratorRef.current) {
//                 map.removeLayer(decoratorRef.current);
//             }

//             decoratorRef.current = createDecorator(offset).addTo(map);

//             animationRef.current = requestAnimationFrame(animate);
//         };

//         animate();

//         return () => {
//             polylineLayersRef.current.forEach(layer => map.removeLayer(layer));
//             polylineLayersRef.current = [];

//             if (decoratorRef.current) map.removeLayer(decoratorRef.current);
//             if (animationRef.current) cancelAnimationFrame(animationRef.current);
//         };

//     }, [map, positions, zoom, arrowIntervalKm, normalizePositions]);

//     return null;
// };

// const ArrowPolyline = ({
//     positions,
//     weight = 5,
//     opacity = 0.9,
//     arrowIntervalKm = 10,
//     isAnimating // 👈 NEW PROP
// }) => {
//     const map = useMap();
//     const polylineRef = useRef(null);
//     const decoratorRef = useRef(null);
//     const animationRef = useRef(null);
//     const [zoom, setZoom] = useState(() => map?.getZoom() || 11);

//     const CLUSTER_DISABLE_ZOOM = 8;

//     const normalizePositions = useCallback((pos) => {
//         if (!pos || pos.length < 2) return [];
//         return pos.map(p => {
//             if (Array.isArray(p)) return [Number(p[0]), Number(p[1])];
//             if (p.latitude && p.longitude) return [Number(p.latitude), Number(p.longitude)];
//             if (p.lat && p.lng) return [Number(p.lat), Number(p.lng)];
//             return null;
//         }).filter(Boolean);
//     }, []);

//     const getDistance = (coords) => {
//         let distance = 0;
//         for (let i = 1; i < coords.length; i++) {
//             const from = L.latLng(coords[i - 1]);
//             const to = L.latLng(coords[i]);
//             distance += from.distanceTo(to);
//         }
//         return distance;
//     };

//     // Track zoom
//     useEffect(() => {
//         if (!map) return;
//         const handleZoom = () => setZoom(map.getZoom());
//         map.on("zoomend", handleZoom);
//         handleZoom();
//         return () => map.off("zoomend", handleZoom);
//     }, [map]);

//     useEffect(() => {
//         if (!map || !positions || positions.length < 2) return;

//         const latlngs = normalizePositions(positions);
//         if (latlngs.length < 2) return;

//         // Cleanup
//         if (polylineRef.current) map.removeLayer(polylineRef.current);
//         if (decoratorRef.current) map.removeLayer(decoratorRef.current);
//         if (animationRef.current) cancelAnimationFrame(animationRef.current);

//         // Draw base polyline
//         const polyline = L.polyline(latlngs, {
//             color: "#1976d2",
//             weight,
//             opacity
//         }).addTo(map);

//         polylineRef.current = polyline;

//         // Hide arrows on low zoom
//         if (zoom <= CLUSTER_DISABLE_ZOOM) return;

//         const totalDistance = getDistance(latlngs);
//         const repeatPercent = Math.max((arrowIntervalKm * 1000 / totalDistance) * 100, 5);

//         // 🔹 STATIC ARROWS (default)
//         const createStatic = () =>
//             L.polylineDecorator(polyline, {
//                 patterns: [
//                     {
//                         offset: "5%",
//                         repeat: `${repeatPercent}%`,
//                         symbol: L.Symbol.arrowHead({
//                             pixelSize: 10,
//                             polygon: true,
//                             pathOptions: {
//                                 color: "red",
//                                 fillColor: "red",
//                                 fillOpacity: 1,
//                                 weight: 0
//                             }
//                         })
//                     }
//                 ]
//             });

//         // 🔥 ANIMATED ARROWS
//         const createAnimated = (offset) =>
//             L.polylineDecorator(polyline, {
//                 patterns: [
//                     {
//                         offset: `${offset}%`,
//                         repeat: `${repeatPercent}%`,
//                         symbol: L.Symbol.arrowHead({
//                             pixelSize: 10,
//                             polygon: true,
//                             pathOptions: {
//                                 color: "black",
//                                 fillColor: "black",
//                                 fillOpacity: 1,
//                                 weight: 0
//                             }
//                         })
//                     }
//                 ]
//             });

//         // 👉 If animation OFF → show static arrows
//         if (!isAnimating) {
//             decoratorRef.current = createStatic().addTo(map);
//             return;
//         }

//         // 👉 If animation ON → run animation
//         let offset = 0;

//         const animate = () => {
//             offset += 0.3;
//             if (offset > 100) offset = 0;

//             if (decoratorRef.current) {
//                 map.removeLayer(decoratorRef.current);
//             }

//             decoratorRef.current = createAnimated(offset).addTo(map);

//             animationRef.current = requestAnimationFrame(animate);
//         };

//         animate();

//         return () => {
//             if (polylineRef.current) map.removeLayer(polylineRef.current);
//             if (decoratorRef.current) map.removeLayer(decoratorRef.current);
//             if (animationRef.current) cancelAnimationFrame(animationRef.current);
//         };

//     }, [map, positions, zoom, arrowIntervalKm, isAnimating, normalizePositions]);

//     return null;
// };

const ArrowPolyline = ({
    positions,
    weight = 5,
    opacity = 0.9,
    arrowIntervalKm = 10,
    isAnimating
}) => {
    const map = useMap();
    const polylineRef = useRef(null);
    const decoratorRef = useRef(null);
    const animationRef = useRef(null);
    const [zoom, setZoom] = useState(map.getZoom());

    const HIDE_ARROW_ZOOM = 8;

    // 🔹 Normalize coordinates
    const normalizePositions = useCallback((pos) => {
        if (!pos || pos.length < 2) return [];
        return pos.map(p => {
            if (Array.isArray(p)) return [Number(p[0]), Number(p[1])];
            if (p.latitude && p.longitude) return [Number(p.latitude), Number(p.longitude)];
            if (p.lat && p.lng) return [Number(p.lat), Number(p.lng)];
            return null;
        }).filter(Boolean);
    }, []);

    // 🔹 Distance calculation
    const getDistance = (coords) => {
        let distance = 0;
        for (let i = 1; i < coords.length; i++) {
            const from = L.latLng(coords[i - 1]);
            const to = L.latLng(coords[i]);
            distance += from.distanceTo(to);
        }
        return distance;
    };

    // 🔹 Speed based on zoom (MAIN FEATURE)
    const getSpeedFromZoom = (zoom) => {
        if (zoom >= 17) return 0.01;
        if (zoom >= 15) return 0.03;
        if (zoom >= 13) return 0.1;
        if (zoom >= 11) return 0.25;
        return 0.35;
    };

    // 🔹 Track zoom changes
    useEffect(() => {
        const handleZoom = () => setZoom(map.getZoom());
        map.on("zoomend", handleZoom);
        return () => map.off("zoomend", handleZoom);
    }, [map]);

    useEffect(() => {
        if (!map || !positions || positions.length < 2) return;

        const latlngs = normalizePositions(positions);
        if (latlngs.length < 2) return;

        // Cleanup old layers
        if (polylineRef.current) map.removeLayer(polylineRef.current);
        if (decoratorRef.current) map.removeLayer(decoratorRef.current);
        if (animationRef.current) cancelAnimationFrame(animationRef.current);

        // 🔹 Draw polyline
        const polyline = L.polyline(latlngs, {
            color: "#1976d2",
            weight,
            opacity
        }).addTo(map);

        polylineRef.current = polyline;

        // 🔹 Hide arrows on low zoom
        if (zoom <= HIDE_ARROW_ZOOM) return;

        const totalDistance = getDistance(latlngs);
        const repeatPercent = Math.max((arrowIntervalKm * 1000 / totalDistance) * 100, 5);

        // 🔹 Static arrows
        const createStatic = () =>
            L.polylineDecorator(polyline, {
                patterns: [
                    {
                        offset: "5%",
                        repeat: `${repeatPercent}%`,
                        symbol: L.Symbol.arrowHead({
                            pixelSize: 10,
                            polygon: true,
                            pathOptions: {
                                color: "red",
                                fillColor: "red",
                                fillOpacity: 1,
                                weight: 0
                            }
                        })
                    }
                ]
            });

        // 🔹 Animated arrows
        const createAnimated = (offset) =>
            L.polylineDecorator(polyline, {
                patterns: [
                    {
                        offset: `${offset}%`,
                        repeat: `${repeatPercent}%`,
                        symbol: L.Symbol.arrowHead({
                            pixelSize: 11,
                            polygon: true,
                            pathOptions: {
                                color: "black",
                                fillColor: "black",
                                fillOpacity: 1,
                                weight: 0
                            }
                        })
                    }
                ]
            });

        // ✅ If animation OFF → show static arrows
        if (!isAnimating) {
            decoratorRef.current = createStatic().addTo(map);
            return;
        }

        // 🔥 Animation loop
        let offset = 0;

        const animate = () => {
            const speed = getSpeedFromZoom(zoom); // 👈 dynamic speed

            offset += speed;
            if (offset > 100) offset = 0;

            if (decoratorRef.current) {
                map.removeLayer(decoratorRef.current);
            }

            decoratorRef.current = createAnimated(offset).addTo(map);

            animationRef.current = requestAnimationFrame(animate);
        };

        animate();

        return () => {
            if (polylineRef.current) map.removeLayer(polylineRef.current);
            if (decoratorRef.current) map.removeLayer(decoratorRef.current);
            if (animationRef.current) cancelAnimationFrame(animationRef.current);
        };

    }, [map, positions, zoom, arrowIntervalKm, isAnimating, normalizePositions]);

    return null;
};

// Custom marker component with memoization
const MemoizedMarker = React.memo(({ position, icon, tooltipContent, index }) => {
    return (
        <Marker position={position} icon={icon}>
            <Tooltip direction="top" offset={[0, -10]} sticky permanent={false}>
                <div className="marker-tooltip" style={{ 
                    maxWidth: '250px', 
                    fontSize: '12px',
                    padding: '8px',
                    backgroundColor: 'white',
                    borderRadius: '4px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                }}>
                    {tooltipContent}
                </div>
            </Tooltip>
        </Marker>
    );
}, (prevProps, nextProps) => {
    const prevPos = prevProps.position;
    const nextPos = nextProps.position;
    return prevPos[0] === nextPos[0] && prevPos[1] === nextPos[1];
});

const MapWithPunchData = () => {
    const [isAnimating, setIsAnimating] = useState(false);
    const [ tripStatus, setTripStatus ] = useState(false);
    const [isLiveTracking, setIsLiveTracking] = useState(false);
    const { travelId, userId } = useParams();
    const [coordinatesWithoutTimeStamp, setCoordinatesWithoutTimestamp] = useState([]);
    const [coordinatesWithTimeStamp, setCoordinatesWithTimeStamp] = useState([]);
    const [currentLocation, setCurrentLocation] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [mapReady, setMapReady] = useState(false);
    const [arrowInterval, setArrowInterval] = useState(10); // default 10 km
    const mapRef = useRef();

    const fetchTravelCoordinatesAPI = async () => {
        try {
            setLoading(true);
            setTripStatus(true);
            // ✅ FIRST API CALL
            const sendRequest = await axios.get(
                `${process.env.REACT_APP_SERVER_ADDRESS}/attendance/travel-tracking?travelId=${travelId}`
            );
            
            if((sendRequest?.data?.data?.trackingSession).length === 0){
                setCoordinatesWithTimeStamp([]);
                setCoordinatesWithoutTimestamp([]);
                return;
            }

            const response = sendRequest?.data?.data?.trackingSession[0];

            console.log("Response:- ", sendRequest?.data);

            if (sendRequest?.data?.success) {
                setTripStatus(response?.status);
            }

            // ✅ Set map data from first API (IMPORTANT → map should show)
            if (response?.locationLogs) {
                setCoordinatesWithTimeStamp(response.locationLogs);
            }

            if (response?.polyline) {
                setCoordinatesWithoutTimestamp(response.polyline);
            }

            // 🛑 STOP HERE if ENDED
            if (response?.status === "ENDED") {
                setTripStatus(false);
                // console.log("Trip ended → skipping current location API");
                setMapReady(true);
                return; // ❗ stops second API
            }

            // ✅ SECOND API CALL (ONLY if NOT ENDED)
            const sendRequest2 = await axios.get(
                `${process.env.REACT_APP_SERVER_ADDRESS}/attendance/travel-tracking/currentLoc?employeeId=${userId}&travelId=${travelId}`
            );

            const response2 = sendRequest2?.data?.data;

            if ((response2.location).length === 2) {
                // console.log("Welcome into the if else condition");
                const lat = response2?.location[0];
                const lng = response2?.location[1];
                if(lat && lng){
                    setCurrentLocation({
                        lat,
                        lng,
                        locationString: response2?.locationStr,
                        timestamp: response2?.timestamp,
                    });
                }else{
                    setCurrentLocation({
                        lat,
                        lng,
                        locationString: response2?.locationStr,
                        timestamp: response2?.timestamp,
                    });
                }
                
            }

            setMapReady(true);

        } catch (error) {
            console.log("The error of travel api data:- ", error.response);
            setError(error.message || "Failed to fetch data");
        } finally {
            setLoading(false);
        }
    };
    const handleFetchCurrentLocation = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_SERVER_ADDRESS}/attendance/travel-tracking/currentLoc?employeeId=${userId}&travelId=${travelId}`
            );

            const data = res?.data?.data;

            if (data?.location && data.location.length === 2) {
                const lat = data.location[0];
                const lng = data.location[1];
                console.log("Lat & Lng:- ", lat, lng)
                let newLocation = {}
                if(lat && lng){
                    newLocation = {
                        lat,
                        lng,
                        locationString: data.locationStr,
                        timestamp: data.timestamp
                    };
                }else{
                    newLocation = {
                        lat: null, 
                        lng: null,
                        locationString: data.locationStr,
                        timestamp: data.timestamp
                    }
                }
                
                setCurrentLocation(newLocation);
                setIsLiveTracking(true);

                // 🎯 Focus map on new location
                if (mapRef.current) {
                    mapRef.current.flyTo([lat, lng], 16, {
                        duration: 1.5
                    });
                }
            }
        } catch (error) {
            console.error("Error fetching current location:", error);
        }
    };

    useEffect(() => {
        fetchTravelCoordinatesAPI();
    }, [travelId]);

    // Memoize processed data to prevent recalculations
    const allPunchCoords = useMemo(() => {
        if (!coordinatesWithTimeStamp?.length) return [];
        return coordinatesWithTimeStamp
            .filter(point => point.latitude && point.longitude)
            .map(({ latitude, longitude, trackedAt, locationString }) => [
                Number(latitude), 
                Number(longitude), 
                trackedAt,
                locationString
            ]);
    }, [coordinatesWithTimeStamp]);


    // Calculate center based on first valid coordinate or current location
    const defaultCenter = useMemo(() => {
        if (currentLocation) {
            return [currentLocation.lat, currentLocation.lng];
        }
        if (allPunchCoords.length > 0 && allPunchCoords[0].length >= 2) {
            return [allPunchCoords[0][0], allPunchCoords[0][1]];
        }
        if (coordinatesWithoutTimeStamp.length > 0) {
            return coordinatesWithoutTimeStamp[0];
        }
        return [28.6139, 77.2090];
    }, [allPunchCoords, currentLocation]);

    // Format date function
    const formatDateTime = useCallback((isoDate) => {
        if (!isoDate) return "";
        return moment(isoDate).format('DD/MM/YYYY hh:mm A')
    }, []);

    // Group markers by cluster for better performance
    const createClusterCustomIcon = function(cluster) {
        return L.divIcon({
            html: `<div class="cluster-custom" style="
                background-color: #1976d2;
                width: 40px;
                height: 40px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: white;
                font-weight: bold;
                font-size: 14px;
                box-shadow: 0 2px 5px rgba(0,0,0,0.3);
                border: 2px solid white;
            ">${cluster.getChildCount()}</div>`,
            className: 'custom-marker-cluster',
            iconSize: L.point(40, 40, true)
        });
    };

    // Calculate total distance for display
    const totalDistance = useMemo(() => {
        if (!coordinatesWithoutTimeStamp.length) return 0;
        let distance = 0;
        for (let i = 1; i < coordinatesWithoutTimeStamp.length; i++) {
            const from = L.latLng(coordinatesWithoutTimeStamp[i-1][0], coordinatesWithoutTimeStamp[i-1][1]);
            const to = L.latLng(coordinatesWithoutTimeStamp[i][0], coordinatesWithoutTimeStamp[i][1]);
            distance += from.distanceTo(to);
        }
        return (distance / 1000).toFixed(2);
    }, [coordinatesWithoutTimeStamp]);

    // Render markers in chunks to prevent blocking
    const renderMarkers = () => {
        if (!allPunchCoords.length) return null;

        return (
            <MarkerClusterGroup
                chunkedLoading
                chunkInterval={50}
                chunkDelay={50}
                spiderfyOnMaxZoom={true}
                showCoverageOnHover={false}
                zoomToBoundsOnClick={true}
                maxClusterRadius={80}
                iconCreateFunction={createClusterCustomIcon}
                disableClusteringAtZoom={15}
            >
                {allPunchCoords.map((data, index) => {
                    if (!data || data.length < 2) return null;
                    
                    const tooltipContent = (
                        <>
                            <strong>Data Point #{index + 1}</strong>
                            <br />
                            🕒 {formatDateTime(data[2])}
                            <br />
                            <strong>Coord:</strong> ({data[0].toFixed(5)}, {data[1].toFixed(5)})
                            <br />
                            <div className="text-wrap">
                                <strong>Location:</strong>({data[3]})
                            </div>
                        </>
                    );

                    return (
                        <MemoizedMarker
                            key={`marker-${index}-${data[0]}-${data[1]}`}
                            position={[data[0], data[1]]}
                            icon={index === 0 ? punchInIcon : punchOutIcon}
                            tooltipContent={tooltipContent}
                            index={index}
                        />
                    );
                })}
            </MarkerClusterGroup>
        );
    };

useEffect(() => {
    const style = document.createElement('style');

    style.textContent = `
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }

        .direction-arrow {
            background: transparent !important;
            border: none !important;
        }

        .direction-arrow div {
            display: inline-block;
            will-change: transform;
            animation: arrowPulse 1.5s ease-in-out infinite;
        }

        @keyframes arrowPulse {
            0%, 100% { 
                opacity: 0.7; 
                transform: scale(1) rotate(var(--rotate)); 
            }
            50% { 
                opacity: 1; 
                transform: scale(1.2) rotate(var(--rotate)); 
            }
        }

        @keyframes pulseLive {
            0% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.6); opacity: 0.6; }
            100% { transform: scale(1); opacity: 1; }
        }
    `;

    document.head.appendChild(style);

    return () => {
        document.head.removeChild(style);
    };
}, []);
    // Loading state
    if (loading) {
        return (
            <div style={{ 
                height: "100vh", 
                width: "100%", 
                display: "flex", 
                alignItems: "center", 
                justifyContent: "center",
                backgroundColor: "#f5f5f5"
            }}>
                <div style={{ textAlign: "center" }}>
                    <div className="spinner" style={{
                        border: "4px solid #f3f3f3",
                        borderTop: "4px solid #3498db",
                        borderRadius: "50%",
                        width: "40px",
                        height: "40px",
                        animation: "spin 1s linear infinite",
                        margin: "0 auto 10px"
                    }} />
                    <p>Loading map data...</p>
                </div>
            </div>
        );
    }

    // Error state
    if (error && tripStatus !== 'ENDED') {
        console.log('Hello', tripStatus);
        return (
            <div style={{ 
                height: "100vh", 
                width: "100%", 
                display: "flex", 
                alignItems: "center", 
                justifyContent: "center",
                backgroundColor: "#f5f5f5"
            }}>
                <div style={{ textAlign: "center", color: "#dc3545" }}>
                    <h3>Error Loading Map</h3>
                    <p>{error}</p>
                    <button 
                        onClick={fetchTravelCoordinatesAPI}
                        style={{
                            padding: "8px 16px",
                            backgroundColor: "#007bff",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            cursor: "pointer"
                        }}
                    >
                        Retry
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div style={{ height: "100vh", width: "100%", position: "relative" }}>
            
            <div style={{
                position: "absolute",
                top: "10px",
                left: "50px",
                zIndex: 1000,
                backgroundColor: "rgba(255,255,255,0.95)",
                padding: "8px 16px",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                display: "flex",
                alignItems: "center",
                gap: "20px",
                flexWrap: "wrap",
                fontSize: "14px",
                fontFamily: "sans-serif"
            }}>
                <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                    🗺️ Employee Punch In/Out Map
                </span>
                {allPunchCoords.length > 0 && (
                    <span style={{ color: "#555" }}>
                        📍 {allPunchCoords.length} locations
                    </span>
                )}
                {totalDistance > 0 && (
                    <span style={{ color: "#555" }}>
                        📏 Total Distance: {totalDistance} km
                    </span>
                )}
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <label htmlFor="arrowInterval" style={{ fontWeight: "500" }}>Arrow every:</label>
                    <select
                        id="arrowInterval"
                        value={arrowInterval}
                        onChange={(e) => setArrowInterval(Number(e.target.value))}
                        style={{
                            padding: "4px 8px",
                            borderRadius: "4px",
                            border: "1px solid #ccc",
                            backgroundColor: "white",
                            cursor: "pointer",
                            fontSize: "14px"
                        }}
                    >
                        <option value={5}>5 km</option>
                        <option value={10}>10 km</option>
                        <option value={15}>15 km</option>
                        <option value={20}>20 km</option>
                        <option value={25}>25 km</option>
                    </select>
                </div>
                <button
                    onClick={() => setIsAnimating(prev => !prev)}
                    style={{
                        padding: "6px 12px",
                        borderRadius: "4px",
                        border: "none",
                        cursor: "pointer",
                        backgroundColor: isAnimating ? "#dc3545" : "#28a745",
                        color: "white",
                        fontWeight: "500"
                    }}
                >
                    {isAnimating ? "⏹ Stop Animation" : "▶ Start Animation"}
                </button>
                <button
                    onClick={handleFetchCurrentLocation}
                    disabled={tripStatus ? false : true}
                    style={{
                        padding: "6px 12px",
                        borderRadius: "4px",
                        border: "none",
                        cursor: "pointer",
                        backgroundColor: "#ff5722",
                        color: "white",
                        fontWeight: "500",
                        cursor: `${tripStatus ? 'pointer' : 'not-allowed'}`
                    }}
                >
                    📡 Get Live Location
                </button>
            </div>

            <MapContainer
                ref={mapRef}
                center={defaultCenter}
                zoom={11}
                style={{ height: "100%", width: "100%" }}
                whenReady={() => setMapReady(true)}
                preferCanvas={true}
                zoomControl={true}
                scrollWheelZoom={true}
            >
                <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    maxZoom={19}
                />

                <MapController center={defaultCenter} shouldUpdate={mapReady} />

                {/* Polyline with user‑selectable arrow interval */}
                {coordinatesWithoutTimeStamp.length > 1 && (
                    <ArrowPolyline 
                        positions={coordinatesWithoutTimeStamp}
                        // polylineColor="#FF5722"
                        weight={3}
                        opacity={0.8}
                        arrowIntervalKm={arrowInterval}
                        isAnimating={isAnimating}
                    />
                )}

                {/* Clustered markers for punch in/out points */}
                {renderMarkers()}

                {/* Current location marker (blue, unclustered, stays on top) */}
                {currentLocation?.lat != null && currentLocation?.lng != null ? (
                    <Marker 
                        position={[currentLocation.lat, currentLocation.lng]} 
                        icon={isLiveTracking ? liveLocationIcon : liveLocationIcon}
                        zIndexOffset={1000}
                    >
                        <Tooltip direction="top" offset={[0, -10]} sticky>
                            <div style={{ maxWidth: '250px', fontSize: '12px', padding: '8px' }} >
                                <strong>
                                    {isLiveTracking ? "🔴 Live Location" : "📍 Current Location"}
                                </strong>
                                <br />
                                🕒 {formatDateTime(currentLocation.timestamp)}
                                <br />
                                <div className="text-wrap">{currentLocation.locationString}</div>
                            </div>
                        </Tooltip>
                    </Marker>
                ) : null }
            </MapContainer>
        </div>
    );
};

export default MapWithPunchData;